// Collapse focus, live events and polling bursts without losing events during a request.
export function createNotificationRefresher(load:()=>Promise<unknown>,delay=50){
 let timer:ReturnType<typeof setTimeout>|undefined,running=false,queued=false,disposed=false;
 const refresh=()=>{
  if(disposed)return;
  if(running){queued=true;return}
  if(timer!==undefined)return;
  timer=setTimeout(async()=>{
   timer=undefined;running=true;
   try{await load()}catch{/* A later live event or poll retries failed requests. */}
   finally{running=false;if(queued){queued=false;refresh()}}
  },delay);
 };
 return {refresh,dispose:()=>{disposed=true;if(timer!==undefined)clearTimeout(timer)}};
}
